import { http } from '@/api/http'
import type { Company, CompanyCreate, CompanyPatch, ProvisionedCompany } from '@/types/api'
import { createCrudService } from '../crud'

const crud = createCrudService<Company, CompanyCreate, CompanyPatch>('platform/companies', { updateMethod: 'patch' })

/**
 * Platform administration of companies (tenants); only a platform admin may
 * call it. There is no delete: a company is deactivated with status=inactive.
 */
export const companiesService = {
  list: crud.list,
  get: crud.get,
  update: crud.update,
  /** Creates the company with its system setup and the owner user in one transaction. */
  async create(body: CompanyCreate) {
    const { data } = await http.post<ProvisionedCompany>('/platform/companies', body)
    return data
  },
}
